enum EmployeeRate {
  GET_EMPLOYEE_RATES = 'employeeRate/getEmployeeRates',
  ADD_EMPLOYEE_RATE = 'employeeRate/addEmployeeRate'
}

export default EmployeeRate;
